import { reset } from "../../slices/leagueSlice";

//import observable from "../../../utils/notification";
export const controls_layout_actions = {
  openShareModel: (state) => {
    state.ShareModelOpen = true;
  },
  updateGeneralModelInfo:(state,action)=>{
    state.generalModelinfo = action.payload
  },
  resetGeneralModelInfo:(state)=>{
    state.generalModelinfo = {
      type:'warning_gender',  // warning_gender , warning_level 
      info:{
        gender:'',
        match_gender:"",
        level:0,
        match_level:0,
      },
      key:'',
      itemIndex:0,
      rowData:{},
      isOpen:false
    }
  },
  toggleDateInputPortal:(state,action)=>{
    state.customDatePortalInputOpen = action.payload
  },
  closeGeneralModelInfo:(state)=>{
    state.generalModelinfo = {
     ...state.generalModelinfo,
     isOpen:false
    }
  },
  storeWindowPathname:(state,action)=>{
    state.windowPathname = action.payload
  },
  closeShareModel: (state) => {
   state.ShareModelOpen = false
  },
  toggleSystemModel: (state,action) => {
    state.SystemModelOpen = action.payload.state;
    if(action.payload.info){
      state.SystemModelInfo = action.payload.info;
    }
    if(action.payload.type){
      state.SystemModelType = action.payload.type;
    }
    if(action.payload.state === false){
      state.SystemModelInfo = {}
      state.SystemModelType = ''
    }
   
  },
  setInviteLink: (state, action) => {
    state.shareModelInfo = {
      ...state.shareModelInfo,
      ...action.payload
    }
  },
   changeViewMode:(state,action)=>{
    state.viewMode = action.payload
  },
  setSortingOption : (state,action)=>{
    state.sortingBy = action.payload
  },
  setCalenderBookingType: (state, action) => {
    state.calenderBookingType =action.payload
  },
  openSideBar:(state) => {
   state.isOpenSidebar = true
  },
  closeSideBar:(state) => {
   state.isOpenSidebar = false
  },
  toggleSideBar:(state) => {
   state.isOpenSidebar = !state.isOpenSidebar
  },
  updateHomeSidebarInfo:(state,action)=>{
    state.homeSidebarInfo = {
      ...state.homeSidebarInfo,
      ...action.payload}
  },
  resetHomeSidebarInfo:(state)=>{
    state.homeSidebarInfo = {
      type:'booking',
      bookingId:0,
      actionType:'new',
      isOpen:false,
      resetCalenderSlot:false
    }
  },
  updatePathQueue:(state,action)=>{
    console.log(action);
    
    if(action.type === 'back'){
      
      state.pathQueue = state.pathQueue.slice(0,state.pathQueue.length-1)
    }else{
      if(state.pathQueue.length > 0){
        console.log(state.pathQueue[state.pathQueue.length-1]);
        
        if(state.pathQueue[state.pathQueue.length-1]  === action.payload.url){
          state.pathQueue = state.pathQueue
        }else{
           state.pathQueue = [...state.pathQueue,action.payload.url]
        }
        
      }else{
         state.pathQueue = [action.payload.url]
      }
      
    }
  },
  updateNewReadedMsgs:(state,action)=>{
    state.newReadedMsgs = [...state.newReadedMsgs,action.payload.id]
  },
  resetNewReadedMsgs:(state)=>{
    state.newReadedMsgs = []
  },
  setDragElementInfo:(state,action)=>{
    state.DragElemntInfo = action.payload
  },
  setFilter:(state,action)=>{
    console.log(action.payload);
    
    state.filter[action.payload.key] = action.payload.filter
  },
  resetFilter:(state,action)=>{
    state.filter = {}  
  }
  // updateDarkMode: (state, action) => {
  //   state.darkMode = action.payload;
  //   localStorage.setItem('theme',state.darkMode?'dark':"light")
  //   const msg = action.payload ? "dark mode activated" : "light mode activated";
  //   observable.notify({ type: "info", msg });
  // },
  // toggleDarkMode: (state) => {
  //   state.darkMode = !state.darkMode;
  //   localStorage.setItem('theme',state.darkMode?'dark':"light")
  //   const msg = state.darkMode ? "dark mode activated" : "light mode activated";
  //   observable.notify({ type: "info", msg });
  // },
}
export const controls_booking_actions = {
  openCalender: (state) => {
    state.calenderOpen = true;
  },
  setBookingId: (state, action) => {
    state.id = action.payload.bookingId;
  }
}
